// src/pages/NotFound404.js

import React, { useState, useEffect } from "react";

const NotFound404 = () => {
  return (
    <div className="loader-container">
      <h4>404 Page Not Found!</h4>
    </div>
  );
};

export default NotFound404;
